import { useEffect } from 'react';
import { ChatContent } from '@features/components/Chat/components/ChatContent';
import { useChatShare } from '@features/components/Chat/contexts/ChatShareContext';
import { useStreamChatContext } from '@features/contexts/ChatProvider';
import { useChatFiltersStore } from '@features/store/chat-filters.store';
import { isNil } from 'lodash-es';
import './ChatWidget.css';
import { CaseStatus, DonorType, OrganType } from '@/api/apis/case';
import { UseChatFiltersReturn } from '../types';

type Props = {
  caseId?: string;
  caseStatus?: CaseStatus;
  organType?: OrganType;
  donorType?: DonorType;
  inlineLayout?: boolean;
  filterState?: UseChatFiltersReturn;
};

export const ChatWidget = ({ caseId, caseStatus, organType, donorType, inlineLayout = false, filterState }: Props) => {
  const { setInitData } = useChatShare();
  const hydrated = useChatFiltersStore((s) => s.hydrated);
  const { streamChatFilters } = useStreamChatContext();

  const ready = hydrated && !isNil(streamChatFilters);

  useEffect(() => {
    if (!ready) return;
    setInitData({ caseStatus, organType, donorType });
  }, [ready, caseStatus, organType, donorType, setInitData]);

  if (!ready) {
    return null;
  }

  return (
    <ChatContent
      caseId={caseId}
      streamChatFilters={streamChatFilters}
      inlineLayout={inlineLayout}
      filterState={filterState}
    />
  );
};
